// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:not_found*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"not_found\"],\"hasOptionalPrefix\":false},{\"path\":\"/investment/funds/:slug\",\"regex\":\"^/investment/funds/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/profile/directpay/managment/:slug\",\"regex\":\"^/profile/directpay/managment/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/simple-trade/:slug\",\"regex\":\"^/simple-trade/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/support/:slug\",\"regex\":\"^/support/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/agah-bank\"},{\"path\":\"/agah-bank/account\"},{\"path\":\"/agah-bank/asoodeh\"},{\"path\":\"/agah-bank/auto-invest\"},{\"path\":\"/agah-bank/auto-invest-activation\"},{\"path\":\"/agah-bank/auto-invest-edit\"},{\"path\":\"/agah-bank/charge\"},{\"path\":\"/agah-bank/charge/history\"},{\"path\":\"/agah-bank/follow-up\"},{\"path\":\"/agah-bank/register\"},{\"path\":\"/agah-bank/settings\"},{\"path\":\"/agah-bank/settings/default-number\"},{\"path\":\"/agah-bank/settings/direct-debit\"},{\"path\":\"/agah-bank/settings/reissue\"},{\"path\":\"/agah-bank/settings/reissue/follow-up\"},{\"path\":\"/agah-bank/transfer\"},{\"path\":\"/asoodeh\"},{\"path\":\"/assets\"},{\"path\":\"/assets/agah-funds\"},{\"path\":\"/assets/agah-issuable\"},{\"path\":\"/assets/etf-securities\"},{\"path\":\"/assets/gold\"},{\"path\":\"/assets/gold/history\"},{\"path\":\"/brokerage-account\"},{\"path\":\"/brokerage-deposit\"},{\"path\":\"/brokerage-deposit/history\"},{\"path\":\"/brokerage-withdrawal\"},{\"path\":\"/brokerage-withdrawal/history\"},{\"path\":\"/credit\"},{\"path\":\"/credit/halalrial\"},{\"path\":\"/credit/received\"},{\"path\":\"/credit/transferred\"},{\"path\":\"/credit-buy\"},{\"path\":\"/credit-buy/history\"},{\"path\":\"/credit-management\"},{\"path\":\"/dashboard\"},{\"path\":\"/fund-award\"},{\"path\":\"/guide\"},{\"path\":\"/investment\"},{\"path\":\"/investment/consulting\"},{\"path\":\"/investment/funds\"},{\"path\":\"/investment/gold\"},{\"path\":\"/investment/gold/buy\"},{\"path\":\"/investment/gold/sell\"},{\"path\":\"/maintenance\"},{\"path\":\"/management\"},{\"path\":\"/management/banner\"},{\"path\":\"/management/cache\"},{\"path\":\"/management/redirectRule\"},{\"path\":\"/offline\"},{\"path\":\"/profile\"},{\"path\":\"/profile/agreement\"},{\"path\":\"/profile/bank-accounts\"},{\"path\":\"/profile/contact-info\"},{\"path\":\"/profile/contact-info/address\"},{\"path\":\"/profile/contact-info/email\"},{\"path\":\"/profile/contact-info/phone\"},{\"path\":\"/profile/directpay/managment\"},{\"path\":\"/profile/security\"},{\"path\":\"/profile/security/password\"},{\"path\":\"/profile/security/sessions\"},{\"path\":\"/profile/security/trusted-devices\"},{\"path\":\"/profile/security/two-step-login\"},{\"path\":\"/profile/security/username\"},{\"path\":\"/profile/sejam-info\"},{\"path\":\"/profile/user-info\"},{\"path\":\"/support\"},{\"path\":\"/auth/error\"},{\"path\":\"/auth/signin\"},{\"path\":\"/auth/signout\"},{\"path\":\"/landing\"},{\"path\":\"/landing/intro\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.7";import * as Sentry from '@sentry/nextjs';
import { env } from 'next-runtime-env';

function initSentry() {
  const dsn = env('NEXT_PUBLIC_SENTRY_DSN');

  if (!dsn) {
    setTimeout(initSentry, 50);
    return;
  }

  Sentry.init({
    dsn: dsn,
    profilesSampleRate: 1.0,
    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,

        mask: ['.mask-value'],
      }),
      Sentry.browserTracingIntegration(),
    ],
    profileLifecycle: 'trace',
    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 0.2,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false, // debug only in dev

    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') {
        const url = breadcrumb.data?.url ?? '';
        if (
          url.includes('yandex.ru') ||
          url.includes('analytics.google.com') ||
          url.includes('yektanet.com')
        ) {
          return null;
        }
      }
      return breadcrumb;
    },
  });
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSentry, { once: true });
  } else {
    initSentry();
  }
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
